import React from 'react'
import { isNotNilOrEmpty } from '@soltalabs/ramda-extra'

import { styled, s } from 'lib/styled'
import { Assessment } from './Assessment'

import {
  JobContainer,
  JobContent,
  SectionContainer,
  DayLabel,
  AssessmentContainer,
} from './styles'

const NameLabel = styled.div`
  margin: 15px 15px 8px 15px;
  color: #111;

  font-size: 18px;
  font-weight: 700;
  letter-spacing: 0.25px;
  line-height: 24px;
  display: flex;
  justify-content: center;
  align-items: center;
`

const SiteCard = ({
  name,
  assessments = [],

  product,
  isSelected,
  isCard = true,
}) => {
  return (
    <JobContainer card={isCard}>
      <JobContent selected={isSelected} card={isCard ? 1 : 0}>
        <div style={s('flex flex-row')}>
          <NameLabel>{name}</NameLabel>
        </div>

        {isNotNilOrEmpty(assessments) ? (
          <>
            <SectionContainer>
              <DayLabel align="left">NOW</DayLabel>
              <DayLabel>TOMORROW</DayLabel>
              <DayLabel align="right">DAY AFTER</DayLabel>
            </SectionContainer>
            <AssessmentContainer>
              {assessments.map((assessment) => (
                <Assessment
                  key={assessment.assessmentValidityPeriodStart}
                  product={product}
                  assessment={assessment}
                />
              ))}
            </AssessmentContainer>
          </>
        ) : (
          <DayLabel align="left" style={s('ml-4 mb-4 uppercase tracking-wide w-a')}>
            No assessments available
          </DayLabel>
        )}
      </JobContent>
    </JobContainer>
  )
}

export { SiteCard }
